// frontend/shared-ui/src/forms/fields/QuickQuantityField.jsx
import React from "react";

const DEFAULT_PRESETS = [1, 5, 10, 25, 50, 100, 500, 1000];

export default function QuickQuantityField({
  label = "Quantity",
  value,
  min,
  unit,
  unitOptions = ["pcs", "m", "km", "roll", "drum", "box", "kg", "set", "pair","bag"],
  onValueChange,
  onUnitChange,
  presets = DEFAULT_PRESETS,
  hint,
  required = false,
  disabled = false,
}) {
  const inputId = `qty-${label.replace(/\s+/g, "-").toLowerCase()}`;

  const bump = (delta) => {
    if (disabled) return;
    const next = Math.max(0, (Number(value) || 0) + delta);
    onValueChange?.(next);
  };

  const setTo = (n) => {
    if (disabled) return;
    onValueChange?.(n);
  };

  return (
    <div className="fh-form-field fh-quick-qty">
      <label
        htmlFor={inputId}
        className={`fh-form-field__label ${required ? "is-required" : ""}`}
      >
        {label}
      </label>

      <div className="fh-quick-qty__row">
        <button
          type="button"
          className="fh-quick-qty__step"
          onClick={() => bump(-1)}
          disabled={disabled}
          aria-label="Decrease by 1"
        >
          −
        </button>

        <input
          id={inputId}
          type="number"
          className="fh-input fh-quick-qty__input"
          value={value ?? ""}
          onChange={(e) => {
            const v = e.target.value;
            onValueChange?.(v === "" ? "" : Number(v));
          }}
          min={min}
          disabled={disabled}
        />

        <button
          type="button"
          className="fh-quick-qty__step"
          onClick={() => bump(1)}
          disabled={disabled}
          aria-label="Increase by 1"
        >
          +
        </button>

        {onUnitChange && (
          <select
            className="fh-input fh-quick-qty__unit"
            value={unit || "pcs"}
            onChange={(e) => onUnitChange(e.target.value)}
            disabled={disabled}
          >
            {unitOptions.map((u) => (
              <option key={u} value={u}>
                {u}
              </option>
            ))}
          </select>
        )}
      </div>

      {/* Quick presets */}
      <div className="fh-quick-qty__presets">
        {presets.map((n) => (
          <button
            key={n}
            type="button"
            className="fh-quick-qty__preset"
            onClick={() => setTo(n)}
            disabled={disabled}
          >
            {n}
          </button>
        ))}
      </div>

      {hint && <div className="fh-form-field__hint">{hint}</div>}
    </div>
  );
}
